import ViewFactory from '../../../packages/creator'
import Schema from '../../../packages/helper/schema'
import { i18n } from '../../../packages/helper/i18n'
import { USER, USER_FLAG, ROLE } from '../../helper/valueMap'
import renderStatus from '../../helper/renderStatus'
import CollectionDescriptor from '../../../packages/helper/resource'
import { format } from '../../helper/ts'
import {MODE} from '../../../packages/constant'

let stationRequest = false;
let roleRequest = false;

export default ViewFactory({
  name: 'Nested View',
  mode: MODE.EDIT_IN_NEW_PAGE,
  data: new CollectionDescriptor('user'),
  schema: [
    new Schema.Hidden('User ID', 'id', false),
    new Schema.Input('User ID', 'id', false, '', {
      editable: false
    }),
    new Schema.Input('Email', 'email', false , {
      asFilter: true,
      inTable: false,
      editable: false
    }),
    new Schema.CheckTree('Role', 'role_list', (state) => [
      { id: 1, label: i18n('a') },
      { id: 2, label: i18n('b') },
      { id: 3, label: i18n('c') },
      { id: 4, label: i18n('d') }
    ], false , {
      asFilter: true,
      inTable: false,
      editable: false
    }),
    new Schema.Input('Email', 'email', true),
    new Schema.Input('Phone', 'phone', true, { group: 'Numbers only' }),
    new Schema.Select('Status', 'status', [
      ...USER.STATUS.map((item, index) => ({
        label: item,
        value: index
      }))
    ], true, {
      asFilter: true,
      inTable: true,
      render: (value, row) => renderStatus({
        type: USER.STATUS_CLASS[value],
        content: USER.STATUS[value]
      }),
      group: 'Selections'
    }),
    new Schema.Select('Flag', 'flag', [
      ...USER_FLAG.STATUS.map((item, index) => ({
        label: item,
        value: index
      }))
    ], true, {
      asFilter: false,
      inTable: true,
      render: (value,row) => renderStatus({
        type: USER_FLAG.STATUS_CLASS[value],
        content: USER_FLAG.STATUS[value]
      }),
      group: 'Selections'
    }),
    new Schema.MultiSelect('Role', 'role_name_list', [], true, {
      asFilter: false,
      inTable: true,
      editable: false
    }),
    new Schema.Datetime('Create Time', 'ctime', false, {
      editable: false,
      render: (date, row) => format(date)
    }),
    new Schema.Datetime('Last Login', 'last_login', false, {
      editable: false,
      render: (date, row) => format(date)
    }),
  ],
  options: {
    tabs: [{
      label: 'a',
      url: 'a'
    },{
      label: 'b',
      url: 'b'
    },{
      label: 'c',
      url: 'c'
    }]
  },
  actions: [
    'edit',
    'detail'
  ],
  hooks: [
    {
      label: i18n('parallel'),
      handler: (router, route) => {
        router.push(route.path + '/user')
      }
    }
  ],
  parallelResource: [{
    mode: MODE.EDIT_IN_NEW_PAGE,
    data: new CollectionDescriptor('role'),
    schema: [
      new Schema.Input('Role ID', 'role_id', false, {
        editable: false,
        asFilter: true,
        render: (value, row) => row['id']
      }),
      new Schema.Input('Role Name', 'name', true),
      new Schema.Select('Status', 'status', [
        ...ROLE.STATUS.map((item, index) => ({
          label: item,
          value: index
        }))
      ], true, {
          asFilter: true,
          render: (value) => renderStatus({
            type: ROLE.STATUS_CLASS[value],
            content: ROLE.STATUS[value]
          })
        }),
      new Schema.Datetime('Create Time', 'ctime', false, {
        editable: false
      }),
      new Schema.Tree('Permission', 'permission_list', state => state.user.permissionTree, true, {
        editable: true,
        inTable: false,
        asFilter: false
      })
    ],
    actions: [
      'edit',
      'detail'
    ],
    hooks: []
  }]
})



// WEBPACK FOOTER //
// ./examples/views/lists/nested.js